<template>
  <div
    class="tag-wrapper"
    @click="showTable = true"
    @mouseleave="showTable = false"
  >
    <span v-if="list.length > 1" class="label  tag-na table-tag-content">
      <!--      @click="fillterMain"-->
      <span class="tagNameDesign">NA</span>
      {{ formatDate(list[0].created_at) }}
      <span class="forNumOutOfName"> {{ naCount }}|{{ list.length }}</span
      ><a @click.prevent="$emit('delete')"
        ><span v-if="showRemove" class="fas fa-times remove-tag-icon"></span></a
    ></span>
    <span v-if="list.length === 1" class="label  tag-na table-tag-content">
      <!--      @click="fillterMain"-->
      <span class="tagNameDesign">NA</span>
      {{ formatDate(list[0].created_at)
      }}<a @click.prevent="$emit('delete')"
        ><span v-if="showRemove" class="fas fa-times remove-tag-icon"></span></a
    ></span>

    <div
      v-if="showTable"
      class="tag-table pop-up-for-tags"
      @mouseleave="showTable = false"
    >
      <div class="table-responsive">
        <table class="table ">
          <thead>
            <tr>
              <th class="t-header">
                <span class="for-last-call" v-if="list.length === 1"
                  >L.C : {{ formatDateLc(list.created_at) }}</span
                >
                <span class="for-last-call" v-if="list.length > 1"
                  >L.C : {{ formatDateLc(list[0].created_at) }}</span
                >
              </th>
              <th class="t-header"></th>
              <th class="t-header"></th>
              <th class="t-header">
                <i
                  class="fa fa-times"
                  aria-hidden="true"
                  @mouseenter="showTable = false"
                ></i>
              </th>
            </tr>
            <tr>
              <th class="t-header">DATE</th>
              <th class="t-header">TIME</th>
              <th class="t-header">AGENT</th>
              <th class="t-header"></th>
              <!--              <th>Vm</th>-->
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in list" :key="item.id">
              <td
                :class="{
                  inBetweenSelectedCalDates: checkSelectedCalDates(item)
                }"
              >
                {{ formatDateTable(item.created_at) }}
              </td>
              <td
                :class="{
                  inBetweenSelectedCalDates: checkSelectedCalDates(item)
                }"
              >
                {{ item.created_at | shortTime }}
              </td>
              <td>{{ item.user.full_name }}</td>
              <td></td>

              <!--              <td v-if="idx < 7 "><span v-if="item.is_vm === 1">Voice Mail</span></td>-->
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapState, mapGetters } from "vuex";

export default {
  name: "na",

  props: {
    list: {
      type: Array,
      required: true
    },
    naCount: {
      type: Object,
      required: true
    },
    showRemove: {
      type: Boolean,
      required: true
    },
    clientFullObj: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showTable: false
    };
  },
  computed: {
    ...mapState("clients", ["generalQueryObject"])
  },
  watch: {},

  methods: {
    checkSelectedCalDates(naDit) {
      let naIn = moment(naDit.created_at);
      let start = moment(this.generalQueryObject.last_modified_na_from).startOf(
        "day"
      );
      let to = moment(this.generalQueryObject.last_modified_na_to).endOf("day");
      if (naIn.isBetween(start, to)) {
        return true;
      } else {
        return false;
      }
    },
    // fillterMain() {
    //   this.$store.commit("clients/setFilterToMain", {
    //     title: "nr",
    //     type: true
    //   });
    // },
    formatDateLc(date) {
      let duration = moment.duration(moment().diff(date));
      duration = duration.humanize();

      if (duration.includes("an")) {
        duration = duration.replace("an", "1 ");
      }
      if (duration.includes("a y")) {
        duration = duration.replace("a ", "1 ");
      }
      if (duration.includes("a d")) {
        duration = duration.replace("a ", "1 ");
      }
      return duration;
    },
    formatDate(date) {
      return moment(String(date)).format("HH:mm DD/MM ");
    },
    formatDateTable(date) {
      return moment(String(date)).format("DD/MM/YY");
    }
  }
};
</script>

<style lang="scss" scoped>
.tag-wrapper {
  display: inline-flex;
  position: relative;
}

.tag-na {
  background-color: #f4511e;
  /*min-width: 128px !important;*/
  /*max-width: 128px !important;*/
  /*font-size: 12px;*/
  /*margin: 2px;*/
  /*font-weight: 500;*/
  /*padding: 3px;*/
  /*!*font-size: 11px;*!*/
  /*line-height: 2;*/
  /*cursor: pointer;*/
  /*font-family: "Montserrat" !important;*/
  /*animation: flash linear 1s;*/
}
.table {
  margin-bottom: 0px !important;
  transform: scaleX(-1);
}

@keyframes flash {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 3;
  }
}

.tag-table {
  bottom: 34px !important;
  /* border-radius: 5px; */
  border: solid 1px #f4511e;
  text-align: center;
  max-height: 267px;
  overflow-y: hidden;
  /*  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);*/
}

.table-responsive {
  margin-bottom: 0px;
  border-radius: 5px;
  overflow: auto;
  max-height: 267px;
  transform: scaleX(-1);
}

.remove-tag-icon {
  /*color: white;*/
  /*cursor: pointer;*/
  /*margin-left: 5px;*/
  color: white;
  cursor: pointer;
  margin-left: 0px;
  position: absolute;
  left: 11px;
  font-size: 17px;
  padding-top: 2px;
  padding-bottom: 2px;
  padding-left: 6px;
  padding-right: 6px;
  //border: 1px solid black;
  border-radius: 5px;
  top: 6px;
  background: black;
}
.remove-tag-icon:hover {
  color: white;
  background: black;
}
/*.remove-tag-icon:hover {*/
/*  color: #f44336;*/
/*}*/
.label {
  padding: 4px 2px 4px 2px;
  font-size: 12px;
}
.tagNameDesign:hover {
  font-size: 12px !important;
}
.forNumOutOfName {
  font-weight: 100;
}
.inBetweenSelectedCalDates {
  /*background: lightgrey;*/
  /*border: 1px solid white !important;*/
  color: blue;
}
tbody > tr:nth-of-type(odd) {
  background-color: #7a7a7a0d;
}
.t-header {
  position: sticky;
  top: 0;
  background-color: white !important;
}
///* width */
//::-webkit-scrollbar {
//  width: 3px;
//}
//
///* Handle */
//::-webkit-scrollbar-thumb {
//  background: grey;
//  border-radius: 10px;
//}
.table-responsive::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}

.table-responsive::-webkit-scrollbar {
  width: 7px;
  background-color: #f5f5f5;
  /*display: none;*/
}

.table-responsive::-webkit-scrollbar-thumb {
  background-color: #7a7a7a;
  border: 2px solid #555555;
  border-radius: 5px;
}
th.t-header {
  z-index: 2;
}
i.fa.fa-times {
  position: absolute;
  top: 12px;
  z-index: 5;
  right: 18px;
}
.for-last-call {
  color: #00a700;
}
.for-last-call {
  color: #00a700;
  font-size: 10px;
  padding-right: 6px;
}
</style>
